import { store } from './store.js';
/**
 * CONFIG MANAGER - Detectimáticas de 1º
 * Gestión de los pasos de configuración (1-3) y renderizado de opciones.
 */

const ConfigManager = {
    init() {
        console.log('⚙️ Inicializando ConfigManager...');
    },


    isNavigating: false,

    openSelection(sectionId) {
        if (this.isNavigating) return;

        // Hide all sections
        document.querySelectorAll('.config-section').forEach(section => {
            section.classList.remove('active');
            section.classList.add('hidden');
        });

        // Show requested section
        const el = document.getElementById(sectionId);
        if (el) {
            el.classList.add('active');
            el.classList.remove('hidden');
            el.classList.remove('fade-in-smooth');
            void el.offsetWidth;
            el.classList.add('fade-in-smooth');
        }

        // Trigger renders
        if (sectionId === 'problemTypeSection') this.renderProblemTypes();
        if (sectionId === 'levelSection') this.renderLevels();
        if (sectionId === 'contextSection') this.renderContextSelection();

        // Update back button state
        this.updateConfigUI();
        
        // Ensure config-nav is hidden
        const nav = document.querySelector('.config-nav');
        if (nav) nav.style.display = 'none';
    },

    goToDashboard() {
        if (this.isNavigating) return;

        // Hide all sections
        document.querySelectorAll('.config-section').forEach(section => {
            section.classList.remove('active');
            section.classList.add('hidden');
        });

        const el = document.getElementById('dashboardSection');
        if (el) {
            el.classList.add('active');
            el.classList.remove('hidden');
            el.classList.remove('fade-in-smooth');
            void el.offsetWidth;
            el.classList.add('fade-in-smooth');
        }
        
        this.updateDashboardUI();
        this.updateScreenBackground();
    },

    updateDashboardUI() {
        if (!store.config) return;
        
        const typeEl = document.getElementById('dashValOperation');
        const levelEl = document.getElementById('dashValLevel');
        const contextEl = document.getElementById('dashValContext');

        if (typeEl) {
            const t = store.config.problemType;
            if (t) {
                const key = 'problemType' + this.capitalize(t);
                const name = window.LANGUAGES[window.currentLanguage]?.strings?.[key] || t;
                typeEl.textContent = name;
            } else {
                typeEl.textContent = 'Tipo de misterio';
            }
        }

        if (levelEl) {
            const l = store.config.level;
            if (l) {
                const key = 'level' + this.capitalize(l);
                const name = window.LANGUAGES[window.currentLanguage]?.strings?.[key] || l;
                levelEl.textContent = name;
            } else {
                levelEl.textContent = 'Rango de detective';
            }
        }

        if (contextEl) {
            const c = store.config.context;
            if (c) {
                const ctxObj = window.CONTEXTS?.find(x => x.id === c);
                const name = ctxObj ? (ctxObj.title[window.currentLanguage] || ctxObj.title['es-ES']) : c;
                contextEl.textContent = name;
            } else {
                contextEl.textContent = 'Escena del misterio';
            }
        }
    },

    startMissionFromDashboard() {
        if (!store.config) return;
        
        // Defaults if pending
        if (!store.config.problemType) store.config.problemType = 'suma';
        if (!store.config.level) store.config.level = 'aprendiz';
        if (!store.config.context) store.config.context = 'cumpleanos';

        if (window.finishConfiguration) window.finishConfiguration();
    },

    startSurpriseMission() {
        if (!store.config) return;
        
        const types = window.PROBLEM_TYPES?.map(t => t.id) || ['suma', 'resta', 'aleatorio'];
        const contexts = ['cumpleanos', 'fruteria', 'granja'];
        
        // Level is preserved if chosen, else random
        if (!store.config.level) store.config.level = 'aprendiz';
        
        store.config.problemType = types[Math.floor(Math.random() * types.length)];
        store.config.context = contexts[Math.floor(Math.random() * contexts.length)];
        
        this.updateDashboardUI();
        
        if (window.finishConfiguration) window.finishConfiguration();
    },
    renderProblemTypes() {
        const grid = document.getElementById('problemTypeGrid');
        if (!grid || !window.PROBLEM_TYPES) return;
        grid.innerHTML = '';

        window.PROBLEM_TYPES.forEach(type => {
            const card = this.createOptionCard(
                type.id,
                type.icon,
                window.LANGUAGES[window.currentLanguage]?.strings?.[`problemType${this.capitalize(type.id)}`],
                "",
                type.color,
                store.config.problemType === type.id
            );

            card.addEventListener('click', (e) => {
                e.stopPropagation();
                if (window.playPop) window.playPop();

                this.selectProblemType(type.id);
            });
            grid.appendChild(card);
        });
    },

    renderLevels() {
        const grid = document.getElementById('levelGrid');
        if (!grid || !window.DIFFICULTY_LEVELS) return;
        grid.innerHTML = '';

        window.DIFFICULTY_LEVELS.forEach(level => {
            const card = this.createOptionCard(
                level.id,
                level.icon,
                window.LANGUAGES[window.currentLanguage]?.strings?.[`level${this.capitalize(level.id)}`],
                window.LANGUAGES[window.currentLanguage]?.strings?.[`level${this.capitalize(level.id)}Desc`],
                level.color,
                store.config.level === level.id
            );

            card.addEventListener('click', (e) => {
                e.stopPropagation();
                if (window.playPop) window.playPop();
                this.selectLevel(level.id);
            });
            grid.appendChild(card);
        });
    },

    renderContextSelection() {
        const grid = document.getElementById('contextSelectionGrid');
        const filtersContainer = document.getElementById('contextFilters');
        if (!grid || !window.CONTEXT_CATEGORIES) return;

        if (filtersContainer) filtersContainer.style.display = 'none';
        grid.innerHTML = '';

        // DEMO MODE: Allowed contexts
        const ALLOWED_CONTEXTS = ['cumpleanos', 'cumpleaños', 'fruteria', 'frutería'];

        // Agregar tarjeta de Sorpresa al inicio
        const surpriseDiv = document.createElement('div');
        surpriseDiv.className = 'context-category';
        
        const surpriseCard = document.createElement('div');
        surpriseCard.className = `context-card`;
        surpriseCard.style.setProperty('--context-color', '#fde68a');
        surpriseCard.style.background = 'linear-gradient(135deg, #fef3c7, #fde68a)';
        surpriseCard.style.color = '#1e293b';
        surpriseCard.setAttribute('data-context-id', 'sorpresa');
        if (store.config.context === 'sorpresa' || store.config.contextExplicit === false) {
            surpriseCard.classList.add('selected');
        }

        const surpriseIcon = document.createElement('span');
        surpriseIcon.className = 'context-icon';
        surpriseIcon.textContent = '🎲';
        
        const surpriseContent = document.createElement('div');
        surpriseContent.className = 'context-card-content';
        const surpriseTitle = document.createElement('h4');
        surpriseTitle.className = 'context-card-title';
        surpriseTitle.textContent = 'SORPRESA';
        surpriseTitle.style.color = '#1e293b';
        const surpriseDesc = document.createElement('p');
        surpriseDesc.className = 'context-card-description';
        surpriseDesc.textContent = '¡Dejemos que el azar decida!';
        surpriseDesc.style.color = '#334155';
        
        surpriseContent.appendChild(surpriseTitle);
        surpriseContent.appendChild(surpriseDesc);
        surpriseCard.appendChild(surpriseIcon);
        surpriseCard.appendChild(surpriseContent);
        
        surpriseCard.onclick = (e) => {
            e.stopPropagation();
            if (window.playPop) window.playPop();
            this.selectContext('sorpresa', true);
        };
        
        surpriseDiv.appendChild(surpriseCard);
        grid.appendChild(surpriseDiv);

        window.CONTEXT_CATEGORIES.forEach(category => {
            const categoryDiv = document.createElement('div');
            categoryDiv.className = 'context-category';
            categoryDiv.setAttribute('data-category-id', category.id);

            const categoryHeader = document.createElement('div');
            categoryHeader.className = 'category-header';

            const headerContent = document.createElement('div');
            headerContent.className = 'category-header-content';

            const categoryIcon = document.createElement('span');
            categoryIcon.className = 'category-icon';
            categoryIcon.textContent = category.icon;

            const categoryTitle = document.createElement('h3');
            categoryTitle.className = 'category-title';
            const catTitleText = category?.title?.[window.currentLanguage] || category?.title?.['es-ES'];
            categoryTitle.textContent = catTitleText;

            const expandIcon = document.createElement('span');
            expandIcon.className = 'category-expand-icon';
            expandIcon.textContent = '→';

            headerContent.appendChild(categoryIcon);
            headerContent.appendChild(categoryTitle);
            categoryHeader.appendChild(headerContent);
            categoryHeader.appendChild(expandIcon);

            const categoryContent = document.createElement('div');
            categoryContent.className = 'category-content';

            const categoryContexts = window.CONTEXTS.filter(ctx => ctx.category === category.id);

            categoryContexts.forEach(context => {
                const isAllowed = ALLOWED_CONTEXTS.includes(context.id);

                const card = document.createElement('div');
                card.className = `context-card ${isAllowed ? '' : 'locked-card'}`;
                card.style.setProperty('--context-color', context.color);
                card.setAttribute('data-context-id', context.id);

                if (!isAllowed) card.style.opacity = '0.6';

                if (store.config.context === context.id) {
                    card.classList.add('selected');
                }

                const contextIcon = document.createElement('span');
                contextIcon.className = 'context-icon';
                contextIcon.textContent = context.icon;

                const content = document.createElement('div');
                content.className = 'context-card-content';

                const title = document.createElement('h4');
                title.className = 'context-card-title'; // Removed no-audio
                const ctxTitleText = context?.title?.[window.currentLanguage] || context?.title?.['es-ES'];
                title.textContent = ctxTitleText;
                if (!isAllowed) title.textContent += ' 🔒';

                const description = document.createElement('p');
                description.className = 'context-card-description'; // Removed no-audio
                const ctxDescText = context?.description?.[window.currentLanguage] || context?.description?.['es-ES'];
                description.textContent = ctxDescText;

                content.appendChild(title);
                content.appendChild(description);

                card.appendChild(contextIcon);
                card.appendChild(content);

                if (isAllowed) {
                    const continueBtn = document.createElement('button');
                    continueBtn.className = 'btn btn-primary btn-sm context-card-btn';
                    continueBtn.innerHTML = `<span>${window.LANGUAGES[window.currentLanguage].strings.continue || 'Continuar'}</span><span>→</span>`;

                    continueBtn.onclick = (e) => {
                        e.stopPropagation();
                        this.selectContext(context.id, true);
                        setTimeout(() => {
                            this.goToDashboard();
                        }, 300);
                    };
                    card.appendChild(continueBtn);
                } else {
                    const lockedText = document.createElement('div');
                    lockedText.className = 'context-card-locked-indicator';
                    lockedText.innerHTML = `<span>🔒 Próximamente</span>`;
                    lockedText.style.color = '#94a3b8';
                    lockedText.style.fontWeight = 'bold';
                    card.appendChild(lockedText);
                }

                // AUDIO ON HOVER REMOVED per user request
                // card.addEventListener('mouseenter', ...);
                // card.addEventListener('mouseleave', ...);

                card.addEventListener('click', (e) => {
                    e.stopPropagation();
                    if (window.playPop) window.playPop();

                    if (isAllowed) {
                        this.selectContext(context.id);
                    } else {
                        if (window.Swal) Swal.fire({
                            icon: 'info',
                            title: 'Modo Demo',
                            text: 'Estás utilizando una demo. Estará disponible en la versión completa.'
                        });
                        if (window.SoundService) window.SoundService.playError();
                    }
                });

                categoryContent.appendChild(card);
            });

            categoryHeader.addEventListener('click', (e) => {
                e.stopPropagation();

                const wasExpanded = categoryContent.classList.contains('expanded');

                // Close others
                document.querySelectorAll('.category-content').forEach(c => c.classList.remove('expanded'));
                document.querySelectorAll('.category-expand-icon').forEach(i => i.style.transform = 'rotate(0deg)');

                if (!wasExpanded) {
                    categoryContent.classList.add('expanded');
                    expandIcon.style.transform = 'rotate(90deg)';

                    // Direct and immediate audio for category
                    console.log('📣 Category header click:', catTitleText);
                    if (window.AudioService) window.AudioService.speak(catTitleText);
                    else if (window.speak) window.speak(catTitleText, window.currentLanguage);
                }

                if (window.playPop) window.playPop();
            });

            categoryDiv.appendChild(categoryHeader);
            categoryDiv.appendChild(categoryContent);
            grid.appendChild(categoryDiv);
        });
    },

    createOptionCard(id, icon, title, description, color, isSelected) {
        const card = document.createElement('div');
        card.className = 'option-card';
        card.setAttribute('data-option-id', id);

        if (isSelected) card.classList.add('selected');

        const iconEl = document.createElement('div');
        iconEl.className = 'option-icon';
        iconEl.textContent = icon;
        iconEl.style.color = color;

        const titleEl = document.createElement('h3');
        titleEl.className = 'option-title';
        titleEl.textContent = title;

        card.appendChild(iconEl);
        card.appendChild(titleEl);

        if (description && description.trim() !== "") {
            const descEl = document.createElement('p');
            descEl.className = 'option-desc';
            descEl.textContent = description;
            card.appendChild(descEl);
        }

        return card;
    },

    selectProblemType(typeId) {
        if (!store.config) return;
        store.config.problemType = typeId;

        document.querySelectorAll('#problemTypeGrid .option-card').forEach(card => card.classList.remove('selected'));
        const activeCard = document.querySelector(`[data-option-id="${typeId}"]`);
        if (activeCard) activeCard.classList.add('selected');

        // Auto TTS removed to prevent audio from playing when advancing screens

        this.updateConfigUI();

        setTimeout(() => {
            this.goToDashboard();
        }, 300);
    },

    selectLevel(levelId) {
        if (!store.config) return;
        store.config.level = levelId;

        document.querySelectorAll('#levelGrid .option-card').forEach(card => card.classList.remove('selected'));
        const activeCard = document.querySelector(`[data-option-id="${levelId}"]`);
        if (activeCard) activeCard.classList.add('selected');

        // Auto TTS removed to prevent audio from playing when advancing screens

        this.updateConfigUI();

        setTimeout(() => {
            if (this.isSecretMission) {
                this.isSecretMission = false;
                const types = window.PROBLEM_TYPES?.map(t => t.id) || ['suma', 'resta', 'aleatorio'];
                const contexts = ['cumpleanos', 'fruteria', 'granja'];
                store.config.problemType = types[Math.floor(Math.random() * types.length)];
                store.config.context = contexts[Math.floor(Math.random() * contexts.length)];
                store.config.contextExplicit = false;
                this.updateDashboardUI();
                if (window.finishConfiguration) window.finishConfiguration();
            } else {
                this.goToDashboard();
            }
        }, 300);
    },

    selectContext(contextId, isFromButton = false) {
        if (!store.config) return;

        if (contextId === 'sorpresa') {
            const contexts = ['cumpleanos', 'fruteria', 'granja'];
            store.config.context = contexts[Math.floor(Math.random() * contexts.length)];
            store.config.contextExplicit = false;
        } else {
            store.config.context = contextId;
            store.config.contextExplicit = true;
        }

        document.querySelectorAll('#contextSelectionGrid .context-card').forEach(card => card.classList.remove('selected'));
        const activeCard = document.querySelector(`[data-context-id="${contextId}"]`);
        if (activeCard) activeCard.classList.add('selected');

        const context = window.CONTEXTS.find(ctx => ctx.id === contextId);
        if (context) {
            // Auto TTS removed to prevent audio from playing when advancing screens
            
            // SONIDOS CONTEXTUALES MÁGICOS
            if (window.SoundService) {
                if (store.config.context === 'cumpleanos' || store.config.context === 'cumpleaños') {
                    window.SoundService.playConfetti();
                } else if (!isFromButton) {
                    window.SoundService.playSuccess();
                }
            }
        }

        this.updateConfigUI();

        // PRECARGA OCULTA DE IMÁGENES (Rendimiento)
        if (window.ExcelLoader && window.ExcelLoader.isLoaded) {
            try {
                const tempConfig = { ...store.config };
                if (!tempConfig.problemType) tempConfig.problemType = 'suma';
                if (!tempConfig.level) tempConfig.level = 'aprendiz';
                
                const pTypeStr = { 'sum': 'sum', 'suma': 'sum', 'addition': 'sum', 'subtraction': 'subtraction', 'resta': 'subtraction', 'sub': 'subtraction', 'aleatorio': null, 'any': null }[tempConfig.problemType] || null;
                const lvlStr = { 1: 'beginner', 2: 'advanced', 3: 'expert', 'aprendiz': 'beginner', 'avanzado': 'advanced', 'experto': 'expert', 'beginner': 'beginner', 'advanced': 'advanced', 'expert': 'expert' }[tempConfig.level] || 'beginner';
                
                const problems = window.ExcelLoader.getProblems(tempConfig.context, lvlStr, pTypeStr, 1);
                if (problems && problems.length > 0 && problems[0].images && problems[0].images.length > 0) {
                    const img = new Image();
                    img.src = problems[0].images[0];
                    console.log('⚡ Precargando imagen para:', tempConfig.context);
                }
            } catch(e) {
                console.warn('Error precargando imagen:', e);
            }
        }

        // Novedad: Si es SORPRESA, volvemos automáticamente al dashboard tras un breve delay
        if (contextId === 'sorpresa') {
            setTimeout(() => {
                this.goToDashboard();
            }, 500);
        }
    },

    updateConfigUI() {
        if (!store.config || !window.LANGUAGES) return;
        const strings = window.LANGUAGES[window.currentLanguage].strings;

        const setTxt = (id, txt) => {
            const el = document.getElementById(id);
            if (el && txt) el.textContent = txt;
        };

        setTxt('configTitle', strings.configTitle);
        setTxt('backText', strings.back);
        setTxt('prevStepText', strings.previous);
        setTxt('nextStepText', strings.continue);
        setTxt('problemTypeTitleText', `1. ${strings.problemTypeTitle || 'Investigaré problemas de:'}`);
        setTxt('levelTitleText', `2. ${strings.levelTitle || '¿Qué clase de investigador eres?'}`);
        setTxt('contextTitleText', `3. ${strings.contextTitle || '¿Dónde transcurre la aventura?'}`);

        document.querySelectorAll('.progress-step').forEach((step, index) => {
            if (index + 1 === store.config.currentStep) {
                step.classList.add('active');
            } else {
                step.classList.remove('active');
            }
        });

        const prevBtn = document.getElementById('prevStepBtn');
        const nextBtn = document.getElementById('nextStepBtn');

        if (prevBtn) {
            // Always show ANTERIOR button now that it goes back to Welcome
            prevBtn.classList.remove('hidden');
        }

        if (nextBtn) {
            nextBtn.disabled = !this.canProceedToNextStep();
        }

        this.updateScreenBackground();
    },

    updateScreenBackground() {
        const configScreen = document.getElementById('configScreen');
        if (!configScreen || !store.config) return;

        let bgImage = '/images/bg_operations.png';
        configScreen.style.backgroundImage = `linear-gradient(rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.4)), url('${bgImage}')`;
    },

    canProceedToNextStep() {
        if (!store.config) return false;
        if (store.config.currentStep === 1) return store.config.problemType !== null;
        if (store.config.currentStep === 2) return store.config.level !== null;
        if (store.config.currentStep === 3) return store.config.context !== null;
        return false;
    },

    capitalize(s) {
        if (typeof s !== 'string') return '';
        return s.charAt(0).toUpperCase() + s.slice(1);
    },

    setupEventListeners() {
        const prevBtn = document.getElementById('prevStepBtn');
        if (prevBtn) {
            prevBtn.onclick = (e) => {
                if (e) e.preventDefault();
                window.prevConfigStep();
            };
        }

        const backBtn = document.getElementById('backBtn');
        if (backBtn) {
            backBtn.onclick = (e) => {
                if (e) e.preventDefault();
                window.prevConfigStep();
            };
        }

        const nextBtn = document.getElementById('nextStepBtn');
        if (nextBtn) {
            nextBtn.onclick = (e) => {
                if (e) e.preventDefault();
                window.nextConfigStep();
            };
        }
    },

    toggleAIMode() {
        if (!store.config) return;
        const aiBtn = document.getElementById('aiModeBtn');
        const aiText = aiBtn ? aiBtn.querySelector('.ai-text') : null;

        if (store.config.mode === 'offline') {
            store.config.mode = 'online';
            if (aiBtn) aiBtn.classList.add('active');
            if (aiText) aiText.textContent = 'EXCEL';
            console.log('🤖 Modo IA activado');
        } else {
            store.config.mode = 'offline';
            if (aiBtn) aiBtn.classList.remove('active');
            if (aiText) aiText.textContent = 'IA';
            if (window.ExcelLoader) window.ExcelLoader.loadProblems();
            console.log('📊 Modo Excel activado');
        }
    }
};

// Global aliases for HTML onclick handlers and external access
window.goToStep = (step) => ConfigManager.goToStep(step);
window.setupConfigEventListeners = () => ConfigManager.setupEventListeners();

window.prevConfigStep = () => {
    console.log('⬅️ Anterior clicked');
    const dashboard = document.getElementById('dashboardSection');
    if (dashboard && dashboard.classList.contains('active')) {
        if (window.SessionManager) window.SessionManager.showWelcomeScreen();
    } else {
        ConfigManager.goToDashboard();
    }
};

window.nextConfigStep = () => {
    console.log('➡️ Continuar clicked. Current Step:', store.config.currentStep);
    if (store.config && store.config.currentStep < 3) {
        ConfigManager.goToStep(store.config.currentStep + 1);
    } else {
        if (window.finishConfiguration) window.finishConfiguration();
    }
};

window.toggleAIMode = () => ConfigManager.toggleAIMode();
window.renderProblemTypes = () => ConfigManager.renderProblemTypes();
window.renderLevels = () => ConfigManager.renderLevels();
window.renderContextSelection = () => ConfigManager.renderContextSelection();
window.updateConfigUI = () => ConfigManager.updateConfigUI();
window.selectProblemType = (id) => ConfigManager.selectProblemType(id);
window.selectLevel = (id) => ConfigManager.selectLevel(id);
window.selectContext = (id, btn) => ConfigManager.selectContext(id, btn);
window.createOptionCard = (id, icon, title, desc, color, sel) => ConfigManager.createOptionCard(id, icon, title, desc, color, sel);

window.ConfigManager = ConfigManager;
window.goToDashboard = () => ConfigManager.goToDashboard();

